import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import GenderService from '@iso/services/SettingsService/ProductService/GenderService';

function* deleteGender({ id }) {
    try {
        yield call(GenderService.deleteOne, id);
        yield put(actions.deleteGenderSucceeded(id));
    } catch (error) {
        yield put(actions.deleteGenderFailed(extractError(error)));
    }
}

function* watchDeleteGender() {
    yield takeEvery(
        types.REQUEST_DELETE_GENDER,
        deleteGender,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteGender),
    ]);
}

export default deleteSaga;
